"use client";

import React from "react";
import Link from "next/link";
import svgPaths from "@/assets/svg/svg-5s97axwnwx";

export default function MobileFooter() {
	return (
		<div className="bg-[#1a2c20] rounded-2xl p-6 mb-4">
			<div className="flex flex-col gap-6">
				{/* Logo */}
				<div className="flex items-center gap-2">
					<div className="w-6 h-6 shrink-0">
						<svg
							className="block size-full"
							fill="none"
							viewBox="0 0 24 24"
						>
							<circle cx="12" cy="12" fill="#52FD8E" r="12" />
							<path
								clipRule="evenodd"
								d={svgPaths.p20133700}
								fill="#1B251F"
								fillRule="evenodd"
							/>
						</svg>
					</div>
					<span className="font-semibold text-xs text-white">
						Tax Lien Vest
					</span>
				</div>

				{/* Links */}
				<div className="flex items-center justify-center gap-10">
					<Link
						href="/about"
						className="text-white text-xs font-medium"
					>
						About
					</Link>
					<Link
						href="/privacy-policy"
						className="text-white text-xs font-medium"
					>
						Privacy Policy
					</Link>
					<Link
						href="/terms-of-service"
						className="text-white text-xs font-medium"
					>
						Terms & Conditions
					</Link>
					<Link
						href="/contact-us"
						className="text-white text-xs font-medium"
					>
						Contact
					</Link>
				</div>
				{/* Copyright */}
				<p className="text-[rgba(255,255,255,0.5)] text-xs text-center">
					© 2024 Tax Lien Vest. All rights reserved.
				</p>
			</div>
		</div>
	);
}
